export default __webpack_public_path__ + "static/media/ftr-bg.af4b2573.png";